module.exports = __webpack_public_path__ + "static/media/George Fitzmaurice.ab3e36de.png";